import baseTheme from './baseTheme';
import siteIds from '../../constants/siteIds';
import {
	budgetSourceTheme,
	giftCardConnectionTheme,
	valuePlusTheme,
	savingsCentralTheme,
	tasteForSavingsTheme,
	homePlayTheme,
	valueAccessTheme,
	essentialsForHomeTheme,
	rizzbatesTheme,
	pulseTheme,
	funSourceTheme
} from './giftCardSiteThemes';

export default function (siteId) {
	switch (siteId) {
		case siteIds.giftCardConnection:
			return giftCardConnectionTheme;
		case siteIds.valuePlus:
			return valuePlusTheme;
		case siteIds.savingsCentral:
			return savingsCentralTheme;
		case siteIds.tasteForSavings:
			return tasteForSavingsTheme;
		case siteIds.homePlay:
			return homePlayTheme;
		case siteIds.valueAccess:
			return valueAccessTheme;
		case siteIds.essentialsForHome:
			return essentialsForHomeTheme;
		case siteIds.rizzbates:
			return rizzbatesTheme;
		case siteIds.pulse:
			return pulseTheme;
		case siteIds.funSource:
			return funSourceTheme;
		// INFO legacy sites all currently share the same theme
		case siteIds.budgetSource:
			return budgetSourceTheme;
		case siteIds.buyersPlus:
			return budgetSourceTheme;
		case siteIds.saversSolution:
			return budgetSourceTheme;
		case siteIds.valueSource:
			return budgetSourceTheme;
		default:
			return baseTheme;
	}
}
